import { Minus, Plus, Trash2 } from "lucide-react";
import { CartItem } from "@/contexts/CartContext";
import { LightningBolt } from "@/components/icons/LightningBolt";

interface CartProductItemProps {
  item: CartItem;
  onUpdateQuantity: (quantity: number) => void;
  onRemove: () => void;
}

export function CartProductItem({
  item,
  onUpdateQuantity,
  onRemove,
}: CartProductItemProps) {
  return (
    <div className="flex gap-3 p-3 rounded-lg bg-secondary/50">
      {/* Image */}
      <div className="w-16 h-16 rounded-lg bg-secondary flex items-center justify-center overflow-hidden flex-shrink-0">
        {item.image_url ? (
          <img
            src={item.image_url}
            alt={item.title}
            className="w-full h-full object-cover"
          />
        ) : (
          <LightningBolt size={24} className="text-primary/30" />
        )}
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0">
        <p className="font-medium text-sm truncate">{item.title}</p>
        {item.meta?.size && (
          <p className="text-xs text-muted-foreground">Talle: {item.meta.size}</p>
        )}
        <p className="text-primary font-bold">
          ${item.unit_price.toLocaleString("es-AR")}
        </p>

        {/* Quantity Controls */}
        <div className="flex items-center gap-2 mt-2">
          <button
            onClick={() => onUpdateQuantity(item.quantity - 1)}
            className="w-6 h-6 rounded bg-secondary flex items-center justify-center hover:bg-secondary/80 transition-colors"
          >
            <Minus size={14} />
          </button>
          <span className="w-8 text-center text-sm">{item.quantity}</span>
          <button
            onClick={() => onUpdateQuantity(item.quantity + 1)}
            className="w-6 h-6 rounded bg-secondary flex items-center justify-center hover:bg-secondary/80 transition-colors"
          >
            <Plus size={14} />
          </button>
          <button
            onClick={onRemove}
            className="ml-auto p-1 text-muted-foreground hover:text-destructive transition-colors"
          >
            <Trash2 size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
